export const READY = 'GIFTYA/READY';
export const READY_SUCCESS = 'GIFTYA/READY_SUCCESS';
export const READY_FAILURE = 'GIFTYA/READY_FAILURE';


export const ready = () => ({
    type: READY
});
export const readySuccess = (data) => ({
    type: READY_SUCCESS,
    data
});
export const readyFailure = () => ({
    type: READY_FAILURE
});